import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'
import { NonceProvider } from '#app/utils/nonce-provider'

if (ENV.MODE === 'production' && ENV.SENTRY_DSN) {
	void import('#app/utils/monitoring.client').then(({ init }) => init())
}

// Read the nonce that was injected during SSR so the client renders
// the same nonce value and avoids a hydration mismatch.
const nonce = document.querySelector('script[nonce]')?.getAttribute('nonce') ?? ''

startTransition(() => {
	hydrateRoot(
		document,
		<NonceProvider value={nonce}>
			<HydratedRouter />
		</NonceProvider>,
	)
})
